// Même grammaire que le backend, pour masquer une question sans aller-retour réseau.
// Le serveur revalide de toute façon : ici c'est du confort, pas de la sécurité.
const TERM = /^\s*([a-zA-Z0-9_]+)\s*(==|!=|>=|<=|>|<|contains|not_contains|is_empty|not_empty)\s*(.*)$/

function flatten(v) {
  if (Array.isArray(v)) return v.join(', ')
  if (typeof v === 'boolean') return v ? 'Oui' : 'Non'
  return v == null ? '' : String(v)
}

function term(raw, ctx) {
  const m = raw.match(TERM)
  if (!m) return true
  const left = flatten(ctx[m[1]])
  const op = m[2]
  const right = m[3].trim().replace(/^["']|["']$/g, '')
  if (op === 'is_empty') return left === ''
  if (op === 'not_empty') return left !== ''
  if (op === 'contains') return left.toLowerCase().includes(right.toLowerCase())
  if (op === 'not_contains') return !left.toLowerCase().includes(right.toLowerCase())
  const numeric = left !== '' && right !== '' && !isNaN(+left) && !isNaN(+right)
  const a = numeric ? +left : left
  const b = numeric ? +right : right
  switch (op) {
    case '==': return a === b
    case '!=': return a !== b
    case '>': return a > b
    case '<': return a < b
    case '>=': return a >= b
    case '<=': return a <= b
    default: return true
  }
}

export function visible(condition, data) {
  if (!condition || !condition.trim()) return true
  const ctx = Object.fromEntries(Object.entries(data || {}).map(([k, v]) => ['form_var_' + k, v]))
  return condition.split('||').some((or) => or.split('&&').every((t) => term(t, ctx)))
}

export function pages(fields) {
  const out = [{ title: '', fields: [] }]
  for (const f of fields) {
    if (f.type === 'page') out.push({ title: f.label, fields: [] })
    else out[out.length - 1].fields.push(f)
  }
  return out.filter((p, i) => i === 0 ? p.fields.length : true)
}
